import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Button } from "@/DesignSystem/Molecules/Button/Button";

import styles from "./PortalCommunicationRevokeAllPopup.module.scss";

interface IPortalCommunicationRevokeAllPopupProps {
    onRevoke: () => void;
    onCancel: () => void;
}

export function PortalCommunicationRevokeAllPopup(props: Readonly<IPortalCommunicationRevokeAllPopupProps>): JSX.Element {
    const { getText } = useTranslation();

    function renderFooter(): JSX.Element {
        return (
            <div className="flex-container flex-end">
                <div className={styles.buttonGroupContainer}>
                    <Button
                        variant="neutral"
                        category="secondary"
                        onClick={() => props.onCancel()}
                        label={getText("CancelLabel")}
                        dataCy="portal-communication-revokeall-popup-cancel-button"
                    />
                    <Button
                        dataCy="portal-communication-revokeall-popup-revoke-button"
                        variant="error"
                        label={getText("RevokeLabel")}
                        onClick={() => props.onRevoke()}
                    />
                </div>
            </div>
        );
    }

    return (
        <Modal
            id="portal-communication-revokeall-popup"
            title={getText("WarningLabel")}
            onClose={() => props.onCancel()}
            showX
            footer={renderFooter()}
            width={500}
            roundTopCorner
            disableOverlayClose
            draggable
            dataCy="portal-communication-revokeall-popup"
        >
            <div>{getText("SharedItem_RevokeAllWarningLabel")}</div>
        </Modal>
    );
}
